/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import MultipleButtonsItems from './MultipleButtonsItems';


const MultioptionsButtons = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'MultioptionsButtons',
    buttons: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);

  const handlerButtonsInfo = (buttons) => {
    const newState = {
      ...state,
      buttons,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      setIsLoading(false);
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <>
      <div className="w-full px-5 rounded-lg flex flex-row pt-4 pb-4">
        <div className="pl-9 w-full">
          <h2 className="w-full font-americaMonoRegular text-xs uppercase text-black mt-4 mb-2">
            Select buttons
          </h2>
          {(!isLoading || state.buttons.length) && <MultipleButtonsItems handlerSetComponentsInParent={handlerButtonsInfo} components={state.buttons} languages={languages} activeLanguage={activeLanguage} />}
        </div>
      </div>
    </>
  );
};

MultioptionsButtons.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
MultioptionsButtons.defaultProps = {
  reusableComponent: null,
};

export default MultioptionsButtons;
